import * as R from 'ramda';
import { Endpoints } from '../../../core/api/endpoints';
import { ApiReducer, makeApiReducer, makeApiAction, makeRsaaTypes } from '../../../core/api/rsaa';
import { addError, noLoadingNoError, addLoading, getLoading } from '../../../core/api/module';
import { ActionType } from '../../../core/redux/actionType';


const KEY_ACTION = ActionType.SetRemindersOnRequest;
const ACTIONS    = [
  ActionType.SetRemindersOnRequest,
  ActionType.SetRemindersOnResponse,
  ActionType.SetRemindersOnError,
];


type Payload = undefined;

type Meta = {
  projectId: number;
  participantId: number;
  value: boolean;
};


/**
 * Dispatch this action to set the state of whether or not the user has set email reminders to 'on'
 */
export const setRemindersOnAction = (
  projectId: number,
  participantId: number,
  value: boolean,
) => makeApiAction<Payload, Meta>({
  method:   'POST',
  endpoint: Endpoints.SetRemindersOn,
  headers:  { 'content-type': 'application/json' },
  body:     state => JSON.stringify({ 
    projectId: projectId,
    participantId: participantId,
    remindersOn: value,
    languageId: state.locale.lang.languageId,
  }),
  types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId, participantId, value }),
  bailout:  state => !!getLoading(state, KEY_ACTION),
});


const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['devPlan', 'emailRemindersOn'], action.meta.value, successState);
};


export const setRemindersOnReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
